import React, { Component } from "react";
import { Auth } from "aws-amplify";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { Form } from "react-bootstrap";
import { Alert } from 'reactstrap';
import LoaderButton from "../components/LoaderButton";
import "./Signup.css";

const schema = Yup.object({
  Email: Yup.string().required()
  .matches(/^[a-zA-Z0-9.!#$%&’'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, 'Invalid email address'),
  Password: Yup.string().required() 
  .min(8, 'Password too short - minimum length is 8 characters')
  .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, 'Password must contain a combination of lowercase, uppercase, numeric and special characters.'),
  ConfirmPassword: Yup.string().required('Confirm Password is a required field'),
});

export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      newUser: "",
      alertMessage: "",
    };
  }

  onDismiss = () => this.setState({ alertMessage: "" });;

  handleSubmit = async event => {

    this.setState({ isLoading: true, alertVisible: "" });

    try {
      const newUser = await Auth.signUp({
        username: event.Email.toLowerCase(),
        password: event.Password
      });
      this.setState({
        newUser
      });
      this.setState({ isLoading: false });
      this.props.emailAddressHandler(event.Email);
      this.props.history.push("/login/verify");
    } catch (e) {
      this.setState({ alertMessage: e.message});
    }
    this.setState({ isLoading: false });
  }

  renderForm() {
    return (
      <div>
      <Formik
      validateOnChange={false}
      validationSchema={schema}
      onSubmit={this.handleSubmit}
      initialValues={{
        Email: '',
        password: '',
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (
      <div>
        <Alert color="warning" isOpen={!this.state.alertMessage == ""} toggle={this.onDismiss} fade={false}>
          <h4 className="alert-heading">Error</h4>
          <p>{this.state.alertMessage}</p>
        </Alert>
        <div className="content">
          <h2>DataStar User Registration</h2>
          <div>Registration allows users to access the DataStar License key that has been allocated to their organisation.</div>
          <div>The organisation is identied from your email domain. If your organisation is not registered please contact <a href = "mailto: sales@absolute.technology">sales@absolute.technology</a></div>
        </div>
        <Form noValidate onSubmit={handleSubmit}>
        <Form.Group controlId="formBasicEmail">
          <Form.Label>Email</Form.Label>
          <Form.Control className="form-control-sm"
            name="Email"
            value={values.Email}
            placeholder="Enter email"
            type="email"
            onChange={handleChange}
            isInvalid={!!errors.Email}
          />
          <Form.Control.Feedback type="invalid">
              {errors.Email}
          </Form.Control.Feedback>
        </Form.Group>
        <Form.Group controlId="formBasicPassword">  
            <Form.Label>Password</Form.Label>
            <Form.Control className="form-control-sm"
              name="Password"
              value={values.Password}
              placeholder="Password"
              onChange={handleChange}
              isInvalid={!!errors.Password}
              type="password"
            />
            <Form.Control.Feedback type="invalid">
                {errors.Password}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group controlId="formBasicPassword">  
            <Form.Label>ConfirmPassword</Form.Label>
            <Form.Control className="form-control-sm"
              name="ConfirmPassword"
              value={values.ConfirmPassword}
              placeholder="Confirm Password"
              onChange={handleChange}
              isInvalid={!!errors.ConfirmPassword}
              type="password"
            />
            <Form.Control.Feedback type="invalid">
                {errors.ConfirmPassword}
            </Form.Control.Feedback>
          </Form.Group>
        <LoaderButton
          block
          bsSize="small"
          type="submit"
          isLoading={this.state.isLoading}
          text="Register"
          loadingText="Registering…"
        />
      </Form>
      </div>
       )}
       </Formik></div>
     );
  }

  render() {
    return (
      <div className="main">
        {this.renderForm()}
      </div>
    );
  }
}
